var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMunduLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.195 90.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mundu__FFFFFF",
    "data-name": "Mundu_#FFFFFF",
    transform: "translate(-15.7 -15.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(134.282 16.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M265.5,248.7h28.758l17.767,64.788a36.127,36.127,0,0,1,.744,8.264,1.487,1.487,0,0,0,2.975,0,31.665,31.665,0,0,1,.744-8.264L334.254,248.7h28.758v85.7H346.485V270.186a31.4,31.4,0,0,1,2.066-10.247c.331-1.074,0-1.818-1.074-2.066a1.37,1.37,0,0,0-1.487,1.074l-21.4,75.365H304.092l-21.4-75.366c-.248-.826-.826-1.24-1.487-1.074a1.381,1.381,0,0,0-1.074,2.066,31.4,31.4,0,0,1,2.066,10.247V334.4H265.665V248.7Z",
    transform: "translate(-265.5 -246.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M397,312.713V274.7h15.618v32.642c0,14.462,3.8,18.511,11.9,18.511,9.008,0,17.271-10.082,17.271-24.957V274.7h15.618v64.292H441.79v-4.049a19.06,19.06,0,0,1,1.983-8.76c.5-1.074,1.24-2.81-.331-3.14-.992-.248-1.322.5-1.818,1.487-3.14,6.363-10.247,15.453-21.4,15.453C406.255,339.984,397,330.976,397,312.713Z",
    transform: "translate(-288.332 -251.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M544.308,300.77v38.013H528.69V306.142c0-14.462-3.8-18.511-11.9-18.511-9.008,0-17.271,10.082-17.271,24.957v26.2H483.9V274.492h15.619v4.049a18.071,18.071,0,0,1-1.983,8.76c-.5,1.074-1.24,2.81.331,3.14.992.248,1.322-.5,1.818-1.487,2.892-6.446,10.247-15.453,21.4-15.453C535.053,273.5,544.308,282.507,544.308,300.77Z",
    transform: "translate(-303.419 -251.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M629.392,246.4v87.678H613.774v-2.81a13.629,13.629,0,0,1,1.735-6.611c.578-1.24,1.074-2.4-.248-2.892-1.074-.331-1.57.826-1.818,1.24-4.545,6.694-10.578,12.065-20.329,12.065-16.693,0-28.014-14.627-28.014-33.138s11.321-33.138,28.014-33.138c10,0,16.775,4.876,20.329,11.9.248.5.992,2.066,2.231,1.487s.5-2.066-.083-3.306a14.406,14.406,0,0,1-1.735-6.694V246.4Zm-15.619,55.532c0-10.247-6.859-19.007-17.023-19.007-10.991,0-16.114,8.76-16.114,19.007s5.124,19.007,16.114,19.007C606.915,320.939,613.774,312.18,613.774,301.932Z",
    transform: "translate(-317.518 -246.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M655.4,312.713V274.7h15.619v32.642c0,14.462,3.8,18.511,11.9,18.511,9.008,0,17.271-10.082,17.271-24.957V274.7h15.619v64.292H700.19v-4.049a19.059,19.059,0,0,1,1.983-8.76c.5-1.074,1.24-2.81-.331-3.14-.992-.248-1.322.5-1.818,1.487-3.14,6.363-10.247,15.453-21.4,15.453C664.655,339.984,655.4,330.976,655.4,312.713Z",
    transform: "translate(-333.196 -251.314)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 45.368,
    cy: 45.368,
    rx: 45.368,
    ry: 45.368,
    transform: "translate(15.7 15.7)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunduLogo);
export default __webpack_public_path__ + "static/media/mundu-logo.99cc5b62b4206724f8ac704fa8a00777.svg";
export { ForwardRef as ReactComponent };